import { useCallback, useRef, useState } from 'react';

export function useInfiniteScroll(canLoadMore: boolean, initialPage?: number) {
  const [page, setPage] = useState(initialPage || 1);

  let bottomObserver = useRef<IntersectionObserver | null>(null);

  const lastElementRef = useCallback(
    (node: HTMLDivElement) => {
      if (!canLoadMore) {
        return;
      }
      if (bottomObserver.current) {
        bottomObserver.current.disconnect();
      }
      bottomObserver.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && canLoadMore) {
          setPage((prev) => prev + 1);
        }
      });
      if (node) bottomObserver.current.observe(node);
    },
    [canLoadMore],
  );

  return [page, lastElementRef, setPage] as const;
}
